import { useContext } from "react";
import { RootStoreContext } from "src/stores/RootStore";
import { useSubscription } from "@apollo/client";
import { SUBSCRIBE_TO_NOTIFICATION_STATE } from "src/api/Notification";
import {
    SubscribeToNotificationState,
    SubscribeToNotificationStateVariables
} from "src/api/generated/SubscribeToNotificationState";

export type NotificationSubscriptionComponentProps = {
    customerid?: string;
    id?: string;
};

export const NotificationSubscriptionComponent = (props: NotificationSubscriptionComponentProps) => {
    const { easyContactStore } = useContext(RootStoreContext);

    const { data, error } = useSubscription<SubscribeToNotificationState, SubscribeToNotificationStateVariables>(
        SUBSCRIBE_TO_NOTIFICATION_STATE,
        {
            variables: {
                id: props.id
            }
        }
    );

    if (error) {
        console.error(
            `Subscription for Notification '${props.id}' failed. The Token is expired or has no persmissions to subscribe to notification updates.`
        );
        easyContactStore.setAbortDirectSend(true);
    }

    if (data?.ec_notifications && data.ec_notifications.length > 0) {
        easyContactStore.setDirectSendReady(true);
    }

    return <></>;
};
